<template>
  <div class="insight-metric text-center">
    <h2 class="metric-value" :style="{ color: color }">
      {{ formatValue(value) }}
    </h2>
    <p class="metric-label text-muted mb-0">{{ label }}</p>
    <div v-if="trend !== null" class="metric-trend mt-2">
      <span :class="['badge', trend > 0 ? 'badge-success' : trend < 0 ? 'badge-danger' : 'badge-secondary']">
        <i class="material-icons" style="font-size: 14px; vertical-align: middle;">
          {{ trend > 0 ? 'arrow_upward' : trend < 0 ? 'arrow_downward' : 'remove' }}
        </i>
        {{ Math.abs(trend) }}%
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightMetric',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        value: 0,
        label: '',
        trend: null,
      }),
    },
    color: {
      type: String,
      default: '#007bff',
    },
  },
  computed: {
    value() {
      return this.data.value || 0;
    },
    label() {
      return this.data.label || 'Metric';
    },
    trend() {
      return this.data.trend !== undefined ? this.data.trend : null;
    },
  },
  methods: {
    formatValue(value) {
      if (value === null || value === undefined) return '-';
      if (typeof value === 'number') {
        // Format large numbers with K, M suffixes
        if (value >= 1000000) {
          return (value / 1000000).toFixed(1) + 'M';
        }
        if (value >= 1000) {
          return (value / 1000).toFixed(1) + 'K';
        }
        return value.toLocaleString();
      }
      return value;
    },
  },
};
</script>

<style scoped>
.insight-metric {
  padding: 2rem 1rem;
}

.metric-value {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.metric-label {
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>

